import { NgModule } from '@angular/core';

// BrowserAnimationsModule from ;
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

// import Select2Component
import { AgmCoreModule } from '@agm/core';
import { NgPipesModule } from 'ngx-pipes';
import { InlineEditorModule } from '@qontu/ngx-inline-editor';


/* internal modules */
import { BlocksModule } from './blocks/blocks.module';
import { CommunicationModule } from './communications/communication.module';
import { SocialComponent } from './social/social.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DataTablesModule } from 'angular-datatables';
import { DataTableModule } from 'angular2-datatable';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { GoogleMapComponent } from './maps/google-map.component';
import { NotesModule } from './notes/notes.module';
import { WizardComponent } from './wizard/wizard.component';
import { WizardStepComponent } from './wizard/wizard-step.component';
import { NgAutoCompleteModule } from 'ng-auto-complete';
import { ChartsModule } from 'ng2-charts-x';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { RemoveSpacesPipe } from './pipes/remove-spaces.pipe';
import { PhonePipe } from './pipes/phone-number.pipe';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { EnumKeysPipe } from './pipes/enum-keys.pipe';
import { EnumTextValuesPipe } from './pipes/enum-keys-text.pipe';
import { EnumStringsPipe } from './pipes/enum-strings.pipe';
import { ContactsDropdownComponent } from '../features/contacts/components/dropdown/contacts-dropdown.component';
import { TeamMemberDropdownComponent } from '../features/team/components/dropdown/team-member-dropdown.component';
import { TeamMemberCardComponent } from '../features/team/components/cards/view/team-member-card.component';
import { AddTeamMemberCardComponent } from '../features/team/components/cards/add/add-team-member-card.component';
import { AddHyphenPipe } from './pipes/add-hyphen.pipe';

import { CallbackFilterPipe } from './pipes/callback-filter.pipe';
import { StartCasePipe } from './pipes/start-case.pipe';
import { SearchFilterPipe } from './pipes/search-filter.pipe';
import { BooleanFilterPipe } from './pipes/boolean-filter.pipe';
// import { UploadFileService } from './upload-file/upload-file.service';
// import { FileDropComponent } from './upload-file/drop/file-drop.component';
import { TagInputModule } from 'ngx-chips';
import { NgxPaginationModule } from 'ngx-pagination';

import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';

import { CountToModule } from 'angular-count-to';
import { TeamSelectorComponent } from '../features/team/components/cards/selector/team-selector.component';
import { BBChartsModule } from './charts/bb-charts.module';
import { PipesModule } from './pipes/pipes-module.module';
import { ProjectComponentsModule } from '../features/projects/components/project-components.module';
import { PrintPDFService } from './print-pdf/print-pdf.service';
import { ExportExcelService } from './export-excel/export-excel.service';
import { TagsModule } from './tags/tags.module';
import { DropdownsModule } from './dropdowns/dropdowns.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { CreateProjectComponent } from '../features/projects/create/create-project.component';
import { TaskModule } from './tasks/task.module';
import { NgxSmartModalModule, NgxSmartModalService } from 'ngx-smart-modal';
import { PaymentModule } from './payments/payment.module';
import { AttachmentsModule } from './attachments/attachments.module';
import { UploadFileModule } from './upload-file/upload-file.module';
import { GridModule } from './grid/grid.module';
// import { FindCompaniesComponent } from './dropdowns/companies/find-companies.component';
// import { TeamMemberViewProjectsComponent } from '../features/projects/components/projects-list/view-projects.component';


// import { Select2Component } from 'angular-select2-component';

// import { SocialModule } from './social.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    // HttpClientModule,
    // NotFoundModule,
    ProjectComponentsModule,
    BlocksModule,
    NotesModule,
    GridModule,
    PipesModule,
    NgAutoCompleteModule,
    ChartsModule,
    DataTablesModule,
    DataTableModule,
    InlineEditorModule,
    TagsModule,
    TaskModule,
    PaymentModule,
    AttachmentsModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    ScrollToModule.forRoot(),
    NgPipesModule,
    TagInputModule,
    NgSelectModule,
    UploadFileModule,
    NgxPaginationModule,
    SweetAlert2Module,
    AngularMultiSelectModule,
    AngularDateTimePickerModule,
    CountToModule,
    DropdownsModule,
    AgmCoreModule.forRoot({
      //apiKey: 'AIzaSyD8jG6CJpf5ObrmAU1Lr_Am34FlK7LI3RQ',
      apiKey: 'AIzaSyBm2OnD1VSw50CRkKCW0lHpqp21ioE5BBc',
      libraries: ['places']
    }),
    NgxSmartModalModule.forRoot()
  ],
  declarations: [
    // Select2Component,
    SocialComponent,
    GoogleMapComponent,
    WizardComponent,
    WizardStepComponent,
    /* pipes */
    ContactsDropdownComponent,
    TeamMemberDropdownComponent,
    TeamMemberCardComponent,
    TeamSelectorComponent,
    CreateProjectComponent,
    AddTeamMemberCardComponent,
    // FileDropComponent,
    // TeamMemberViewProjectsComponent
  ],
  exports: [
    // Shared Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // HttpClientModule,
    // NotFoundModule,
    GridModule,
    RouterModule,
    AgmCoreModule,
    NgPipesModule,
    DropdownsModule,
    NgAutoCompleteModule,
    NgSelectModule,
    BBChartsModule,
    SweetAlert2Module,
    AttachmentsModule,
    DataTableModule,
    ChartsModule,
    ProjectComponentsModule,
    PipesModule,
    DataTablesModule,
    InlineEditorModule,
    BsDatepickerModule,
    TimepickerModule,
    ScrollToModule,
    AngularMultiSelectModule,
    NgxPaginationModule,
    AngularDateTimePickerModule,
    CountToModule,
    TagInputModule,
    // Custom Components
    BlocksModule,
    CommunicationModule,
    PaymentModule,
    TaskModule,
    NotesModule,
    SocialComponent,
    GoogleMapComponent,
    WizardComponent,
    WizardStepComponent,
    ContactsDropdownComponent,
    TeamMemberDropdownComponent,
    TeamMemberCardComponent,
    CreateProjectComponent,
    TeamSelectorComponent,
    AddTeamMemberCardComponent,
    NgxSmartModalModule,
    // FindCompaniesComponent
    // TeamMemberViewProjectsComponent
  ],
  providers: [
    PrintPDFService,
    ExportExcelService,
    NgxSmartModalService
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./client/app/shared/shared.module.ts